import Cookies from 'js-cookie';

export const getExpiration = (minutes) =>
    (new Date(new Date().getTime() + 60 * minutes * 1000));

// Session cookie (no `expires`): the token lives until the browser process closes.
// The access JWT itself is short-lived (~30 min, see backend JWT_ACCESS_EXPIRATION_MINUTES) —
// fetchHelper.js transparently refreshes it via the stored refresh token on a 401, so staying
// logged in doesn't depend on the access token's own lifetime. Closing the browser (which drops
// this session cookie) is what actually ends the session.
class cookieService {

    // expiresDays: omit for a session cookie (dies when the browser closes, see above); pass a
    // number of days for a cookie that should survive restarts (e.g. the trusted-device token).
    setCookie(cookieName, value, expiresDays) {
        Cookies.set(cookieName, value, {
            sameSite: 'strict',
            secure: window.location.protocol === 'https:',
            ...(expiresDays ? { expires: expiresDays } : {}),
        });
    }

    getCookie(cookieName) {
        return Cookies.get(cookieName);
    }

    deleteCookie(cookieName) {
        Cookies.remove(cookieName);
    }

}

export default new cookieService();
